import * as Enumerable from 'linq';
import { TenantSubscription } from '../entities/tenant/tenant';
import { RightRule, SecurityModule, SecurityModuleDomain, SecurityModuleTag, SecurityRight } from './security.module';

export abstract class BaseSecurityModule<T> implements SecurityModule<T> {

    constructor(
        public name: string,
        public rights: SecurityRight<T>[],
        public domain = SecurityModuleDomain.Web,
        public plan = TenantSubscription.Core,
        public tags: SecurityModuleTag[] = [],
        public rules: RightRule[] = []) {

        this._id = name;
    }

    _id: string;

    get allRights(): any[] {

        const rights = Enumerable.from(this.rights)
            .select(x => x._id)
            .toArray();
        return rights;
    }

    public allExceptRights(exceptRights: any[]) {

        const rights = Enumerable.from(this.rights)
            .select(x => x._id)
            .where(x => !exceptRights.includes(x))
            .toArray();
        return rights;
    }

}
